import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeoService } from '@app/core/seo/seo.service';

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  styleUrl: './app.css',
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('edutrip');

  constructor() {
    const seo = inject(SeoService);
    seo.setJsonLd('org', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: seo.appName,
      url: `${seo.siteUrl}/`,
      logo: seo.absoluteUrl('/assets/images/logo.png'),
    });
  }
}
